export default __webpack_public_path__ + "static/media/alert-fail.086a7d14.svg";